module.exports = __webpack_public_path__ + "img/lnr-phone-handset.54bc4262.svg";